import styled from 'styled-components';
import { TaskProps, TaskType as TaskTypes } from '../../services/task';

interface Props {
    parent?: TaskProps['id'],
    type: TaskProps['type'],
}

export default function TaskType({ parent, type }: Props) {
    return (
        <Wrapper className={`task-type-container ${parent && 'multiple'}`}>
            {type === TaskTypes.REPETITIVE && <div className="task-type repetitive" title="Daily" />}
            {type === TaskTypes.ONEOFF && <div className="task-type oneoff" title="Once" />}
            {(type === TaskTypes.GOAL || parent) && <div className="task-type goal" title="Goal" />}
        </Wrapper>
    )
}

const Wrapper = styled.div`
    grid-area: type;
    display: flex;
    justify-content: center;
    align-items: center;

    &.multiple {
        .task-type:first-child {
            border-radius: 4px 0 0 4px;
        }

        .task-type:last-child {
            border-radius: 0px 4px 4px 0;
        }

        .task-type {
            width: 30px;
        }
    }

    .task-type {
        height: 4px;
        width: 40px;
        border-radius: 4px;
        transition: transform var(--ui-animation-duration);
        
        &.repetitive { background-color: #00796b; }
        &.oneoff { background-color: #1976d2; }
        &.goal { background-color: #e64a19; }
    }
`